export default __webpack_public_path__ + "static/media/gilroy-semibold.4b11ebb0.otf";